import { React } from 'react';
import { Image } from 'react-bootstrap';

const ItemsSection = props => {
    return (
        <section style={props.background ? { backgroundImage: "url(" + props.background + ")", backgroundRepeat: "inherit" } : {}} className={props.noPadBottom ? 'ItemsSection section-padding noPadBottom' : props.noPadBottomMobile ? 'ItemsSection section-padding noPadBottomMobile' : 'ItemsSection section-padding'}>
            <div className='section-title'>
                <p className='m-0'>{props.t('homepage:' + props.content + '.sectionTitle')}</p>
                <Image fluid src={props.lineContainer} className='line d-none d-lg-block' />
            </div>
            <div className='banner flex-column align-items-lg-center flex-lg-row'>
                <div className='title m-0 col-12'>
                    <h2 className='text-uppercase'>{props.t('homepage:' + props.content + '.title1')}</h2>
                    <h2 className='text-uppercase'>{props.t('homepage:' + props.content + '.title2')}</h2>
                </div>
                <div className="corner d-none d-lg-block">
                    <Image src={props.cornerContainer} />
                </div>
                <div className="white-box col-xl-8 col-lg-7 col-xs-12">
                    <div className="text">
                        <p className="m-0">{props.t('homepage:' + props.content + '.text')}</p>
                    </div>
                </div>
            </div>
            <div>
                {props.children}
            </div>
        </section>
    )
}

export default ItemsSection;